import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postClockOutHost = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-host/presences/clock-out`,
    data: payload,
  });

  return data?.data;
};

export default postClockOutHost;
